export const DEFAULT_WIDTH = 550;
export const DEFAULT_MIN_WIDTH = 550;
export const DEFAULT_MIN_HEIGHT = 400;

// WebSocket close codes
export const WS_CLOSE_POLICY_VIOLATION = 1008;
export const WS_CLOSE_TRY_AGAIN_LATER = 1013;

// error codes
export const WORKFLOW_NOT_FOUND_CODE = 'WORKFLOW_NOT_FOUND';
export const NO_RESOURCE_PERMISSIONS = 'NO_RESOURCE_PERMISSIONS';
export const NO_DEFAULT_NAMESPACE_CODE = 'NO_DEFAULT_NAMESPACE';

export const FEEDBACK_TRACKING_EVENT = 'ai_duo_agentic_chat_feedback_submitted';
export const CHAT_TRACKING_EVENT = 'trigger_ai_catalog_item';

export const TRACKING_EVENT_VIEW_EMPTY_STATE = 'view_dap_trial_or_paid_empty_state';
export const TRACKING_EVENT_CLICK_AGENT = 'click_dap_trial_or_paid_empty_state_agent';
export const TRACKING_EVENT_CLICK_PROMPT = 'click_dap_trial_or_paid_empty_state_prompt';
export const TRACKING_EVENT_CLICK_EXPLORE_AGENTS =
  'click_dap_trial_or_paid_empty_state_explore_agents_link';
export const TRACKING_EVENT_SUBMIT_MESSAGE = 'submit_dap_trial_or_paid_empty_state_message';

export const SUGGESTED_AGENTS_LIMIT = 3;

export const TRACKING_EVENT_RECOMMEND_TOOL = 'recommend_tool_duo_chat';
export const TRACKING_EVENT_TOOL_SUCCEEDED = 'tool_succeeded_duo_chat';
export const TRACKING_EVENT_TOOL_FAILED = 'tool_failed_duo_chat';
export const TRACKING_EVENT_APPROVE_TOOL = 'approve_tool_duo_chat';
export const TRACKING_EVENT_DENY_TOOL = 'deny_tool_duo_chat';
export const TRACKING_EVENT_CLICK_THROUGH_FLOW_WIDGET = 'click_through_flow_widget';

export const TRIGGER_SOURCE_WEB_CHAT = 'web_chat';
export const TRIGGER_SOURCE_WEB_UI = 'web_ui';

export const TOOL_NAME_CLARIFICATION_QUESTION = 'clarification_question';
export const MESSAGE_SUB_TYPE_CLARIFICATION_ANSWER = 'clarification_answer';
